import React from "react";
import {Box, Typography} from "@mui/material";

export default function BookingHeader({reservation}) {
    if (!reservation) return null;

    return (
        <Box sx={{
            display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, flexWrap: "wrap"
        }}>
            <Box>
                <Typography variant="h1" sx={{mb: 0}}>Détails réservation</Typography>
                <Typography variant="subtitle2" color="text.secondary">
                    {reservation.bookingRef ?? "Inconnu"} — {reservation.client.name}
                </Typography>
            </Box>
        </Box>
    );
}
